import { render, staticRenderFns } from "./MetabaseAnalytics.vue?vue&type=template&id=295edffc&"
import script from "./MetabaseAnalytics.vue?vue&type=script&lang=js&"
export * from "./MetabaseAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseAnalytics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports